export default __webpack_public_path__ + "static/media/slider3.6189e2de.jpg";